var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRitualAscendancy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "lost_memory_fragments"), /*#__PURE__*/React.createElement("path", {
    d: "M15.943 1.171l-7.861 10.758 2.067 2.676 5.794-7.861 5.914 7.861 2.061-2.676-7.975-10.758z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.349 9.086h-4.349l15.943 21.744 16.057-21.744h-4.456l-11.601 15.615-11.594-15.615z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.943 12.825l-2.174 2.73 2.174 2.897 2.121-2.73-2.121-2.897z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.235 17.007l2.174 3.118-2.007 2.455h-4.068l3.9-5.573z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58 21.964l1.9 2.569-1.733 2.174h-3.847l3.68-4.743z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.085 21.964l-1.786 2.455 1.733 2.121h3.619l-3.566-4.576z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.872 19.79l1.947-2.616 3.847 5.406-3.68-0.167-2.114-2.623z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.819 5.071l-3.512 4.743-1.84-2.288 1.84-2.455h3.512z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58 5.071l1.9 2.455-1.9 2.455-3.68-4.911h3.68z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRitualAscendancy);
export default __webpack_public_path__ + "static/media/ritual-ascendancy.c5ba2ca0a033ef5a18938cd43a837b94.svg";
export { ForwardRef as ReactComponent };